module.exports = ["baru saja","%s detik yang lalu","%s menit yang lalu","%s jam yang lalu","%s hari yang lalu","%s minggu yang lalu","%s bulan yang lalu","%s tahun yang lalu"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/id-ID.json
// module id = Q/Ht
// module chunks = 1